import React, { useContext, useRef, useEffect, useState } from 'react'
import myContext from '../context/context'
import PropTypes from 'prop-types'
import { isFilterApplied } from '../../Utility/Utility.js'
// // import GetSearchResult from '../../Utility/GetSearchResult/GetSearchResult'
import SearchCriteriaCls from '../../FiltersComponent/SearchCriteria/SearchCriteriaCls'
import SearchFieldsCls from '../../FiltersComponent/SearchFields/SearchFieldsCls'
import ApplyFilters from '../../FiltersComponent/ApplyFilters/ApplyFilters'

// const ClearFilters = props => {
const ClearFilters = props => {
    const { criteriaToApply, classes } = props
    const { searchFields, setSearchFields, searchCriteria, setSearchCriteria, setSearchResult } = useContext(myContext)
    const ApplyFiltersRef = useRef()
    const [criteriaProcessed, setCriteriaProcessed] = useState(false)

    useEffect(() => {

        if (criteriaProcessed) {
            // console.log('useEffect  criteriaProcessed')
            setCriteriaProcessed(false)
            ApplyFiltersRef.current.callhandleClick()
        }

    }, [criteriaProcessed])


    // useEffect(() => {
    //     return () => {
    //         console.log('useEffect return')
    //         if (criteriaProcessed) {
    //             console.log('useEffect return criteriaProcessed')
    //             setCriteriaProcessed(false)
    //             ApplyFiltersRef.current.callhandleClick()
    //         }
    //     }
    // })

    const handleClear = () => {

        const newSearchFields = { ...searchFields }
        const newSearchCriteria = { ...searchCriteria }

        const SearchCriteriaClsObj = new SearchCriteriaCls()
        const searchCriteria_new = SearchCriteriaClsObj.GetSearchCriteria()

        const SearchFieldsClsObj = new SearchFieldsCls()
        const searchFields_new = SearchFieldsClsObj.GetSearchFields()

        newSearchCriteria.pagination.from = 0

        for (const [key] of Object.entries(searchFields)) {
            if (((key === criteriaToApply) && Array.isArray(newSearchFields[key]))) {

                if (key === 'locationFields') {
                    newSearchFields[key].forEach(item => {
                        if (item.isChecked) {
                            item.isChecked = false
                        }
                    })
                } else {
                    newSearchFields[key] = searchFields_new[key]
                }
                newSearchCriteria[key] = []
            }
            if (criteriaToApply === 'all' && key === 'polygon') {
                newSearchCriteria[key] = searchCriteria_new[key]
            }
        }

        setSearchFields({ ...newSearchFields })
        // setSearchCriteria({ ...newSearchCriteria })

        if (criteriaToApply === 'all' || !isFilterApplied(newSearchCriteria)) {
            setSearchResult({ property: [], totalCount: 0 })
            setSearchFields({ ...searchFields_new })
            // setSearchCriteria({ ...searchCriteria_new })
        }

        if (isFilterApplied(newSearchCriteria)) {
            setCriteriaProcessed(true)
        }

        if (criteriaToApply === 'all') {
            setSearchCriteria({ ...searchCriteria_new })
        } else {
            setSearchCriteria({ ...newSearchCriteria })
        }

        // console.log('clear searchCriteria_new:::', searchCriteria_new)
        // console.log('clear searchFields_new:::', searchFields_new)
    }

    return (
        <>
            <button data-testid="button-clear-all" onClick={handleClear} className={classes} type="button">Clear all</button>
            <div className="hidden">
                <ApplyFilters ref={ApplyFiltersRef} handleClose={() => { }} criteriaToApply="all"></ApplyFilters>
            </div>
        </>
    )
}

export default ClearFilters

ClearFilters.propTypes = {
    criteriaToApply: PropTypes.string,
    classes: PropTypes.string
}
